(function () {
  var MQ_DESKTOP = window.matchMedia('(min-width: 750px)');

  function isContactHost() {
    return window.ciwLaHostApi ? window.ciwLaHostApi.isContactLens() : !!document.querySelector('.cl-section');
  }

  function isGlassesHost() {
    if (window.ciwLaHostApi && window.ciwLaHostApi.isContactLens && window.ciwLaHostApi.isContactLens()) {
      return false;
    }
    return !!document.querySelector('.ciw-pdp') && !document.querySelector('.cl-section');
  }

  function portalCloseOnGlassesMobile() {
    if (MQ_DESKTOP.matches || !isGlassesHost() || !document.body.classList.contains('la-modal-open')) {
      return;
    }

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return;

    document.querySelectorAll('.la-prescription-modal-close').forEach(function (btn) {
      if (btn.parentElement === modal) return;
      modal.appendChild(btn);
    });
  }

  function ensureContactHeaderInWrapper() {
    if (MQ_DESKTOP.matches || !isContactHost() || !document.body.classList.contains('la-modal-open')) {
      return;
    }

    var wrapper = document.querySelector('.la-prescription-modal-wrapper');
    var header = document.getElementById('la-prescription-modal-header');
    if (!wrapper || !header || header.parentElement === wrapper) return;

    var parent = header.parentElement;
    if (parent && parent.classList.contains('la-prescription-modal-image')) {
      wrapper.insertBefore(header, wrapper.firstChild);
    }
  }

  function ensureCloseVisible() {
    if (!document.body.classList.contains('la-modal-open')) return;

    ensureContactHeaderInWrapper();

    document.querySelectorAll('.la-prescription-modal-close').forEach(function (btn) {
      btn.style.setProperty('visibility', 'visible', 'important');
      btn.style.setProperty('opacity', '1', 'important');
      if (!btn.classList.contains('ciw-la-gusa-close-btn') && !btn.classList.contains('ciw-la-contact-close-btn')) {
        btn.style.setProperty('display', 'block', 'important');
      }
      btn.style.setProperty('pointer-events', 'auto', 'important');
    });
  }

  function portalCloseOnDesktop() {
    if (!MQ_DESKTOP.matches || !document.body.classList.contains('la-modal-open')) return;

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return;

    document.querySelectorAll('.la-prescription-modal-close').forEach(function (btn) {
      var header = document.getElementById('la-prescription-modal-header');
      if (!header || btn.parentElement === modal) return;
      if (header.parentElement && header.parentElement.classList.contains('la-prescription-modal-image')) {
        modal.appendChild(btn);
      }
    });
  }

  function portalCloseOnContactMobile() {
    if (MQ_DESKTOP.matches || !isContactHost() || !document.body.classList.contains('la-modal-open')) {
      return;
    }

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return;

    ensureContactHeaderInWrapper();

    document.querySelectorAll('.la-prescription-modal-close').forEach(function (btn) {
      if (btn.parentElement === modal) return;
      modal.appendChild(btn);
    });
  }

  function bindModalObserver() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal || modal.dataset.ciwCloseVisibleObs === '1') return;
    modal.dataset.ciwCloseVisibleObs = '1';

    new MutationObserver(function () {
      ensureCloseVisible();
      portalCloseOnDesktop();
      portalCloseOnGlassesMobile();
      portalCloseOnContactMobile();
    }).observe(modal, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'],
    });
  }

  function onModalOpen() {
    ensureCloseVisible();
    portalCloseOnDesktop();
    portalCloseOnGlassesMobile();
    portalCloseOnContactMobile();
    bindModalObserver();
    requestAnimationFrame(function () {
      ensureCloseVisible();
      portalCloseOnDesktop();
      portalCloseOnGlassesMobile();
      portalCloseOnContactMobile();
    });
    [50, 150, 400, 800].forEach(function (ms) {
      setTimeout(function () {
        ensureCloseVisible();
        portalCloseOnDesktop();
        portalCloseOnGlassesMobile();
        portalCloseOnContactMobile();
      }, ms);
    });
  }

  document.addEventListener('LensAdvizor:selectLensModal:open', onModalOpen);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class' && document.body.classList.contains('la-modal-open')) {
        onModalOpen();
      }
    });
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
